import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import Swal from "sweetalert2";

const NavbarGroup = () => {
    const navigate = useNavigate();
    
    return (
        <div className="navbar-gradient">
            <nav className="navbar navbar-expand-lg container  ">
                <Link className="navbar-brand" to="/">
                    <img src={require('../assets/logo_blanco-2.png')} className="d-inline-block align-top" alt="Logo" />
                </Link>
                <div className="d-flex">
                    <h3><a href={process.env.REACT_APP_BACK_URL}><img src={require('../assets/arrow1.png')} width="25" height="17" alt="back" /> Regresar</a></h3>
                    <h3><button onClick={() => {
                        Swal.fire({
                            text: '¿Estás seguro de cerrar sesión?',
                            icon: 'question',
                            showDenyButton: true,
                            confirmButtonText: 'Confirmar',
                            denyButtonText: `Cancelar`,
                            })
                        .then((result) => {
                            if(result.isConfirmed) {
                                // Log out
                                localStorage.removeItem('tokenGroup');
                                localStorage.removeItem('userGroup');
                                // Redirect
                                navigate('/login');
                            }
                        });
                    }} style={{background: 'transparent', border: 'none'}} title="Cerrar sesión" className="p-1"><FontAwesomeIcon style={{color: '#FFF',fontSize: '18px', marginLeft: '15px'}} icon={faRightFromBracket} /></button></h3>
                </div>
            </nav>
        </div>
    );
    
}
 
export default NavbarGroup;